import { GenericConversation } from "../thirdparty-conversation-item";

export interface ThirdpartyTaskConversation {
    taskFormId: number;
    formConversations: ThirdpartyTaskConversationItem[];
    itemsConversations: ThirdpartyTaskConversationItem[];
}

export class ThirdpartyTaskConversationItem implements GenericConversation {
    id: number;
    title: string = '';
    message: string = '';
    createDate: string = new Date().toISOString();
    userId: number = 0;
    thirdPartyFollowUpTaskFormId?: number;
    thirdPartyFollowUpTaskFormItemId: number = 0;
    isFormComment: boolean = false;
    canBeDeleted?: boolean;

    constructor(
        message: string,
        formItemId: number,
        userId: number
    ) {
        this.id = 0;
        this.title = message.split(' ')[0]; // me quedo con la primera palabra.. por ahora
        this.message = message;
        this.thirdPartyFollowUpTaskFormItemId = formItemId;
        this.userId = userId;
    }
}

export class ThirdpartyTaskFormConversationItem implements GenericConversation {
    id: number;
    title: string = '';
    message: string = '';
    createDate: string = new Date().toISOString();
    userId: number = 0;
    thirdPartyFollowUpTaskFormId?: number;
    thirdPartyFollowUpTaskFormItemId: number = 0;
    isFormComment: boolean = true;
    canBeDeleted?: boolean;

    constructor(
        message: string,
        formId: number,
        userId: number
    ) {
        this.id = 0;
        this.title = message.split(' ')[0]; // me quedo con la primera palabra.. por ahora
        this.message = message;
        this.thirdPartyFollowUpTaskFormItemId = formId;
        this.userId = userId;
    }
}
